import { ProgramStatusFilter } from './program-status-filter';

export function ProgramFilters() {
  return (
    <div className='flex flex-col gap-4'>
      <ProgramStatusFilter />
    </div>
  );
}
